import React from 'react';
import ReactDOM from 'react-dom/client'; // modern React 18+ entrypoint
import { CookiesProvider } from 'react-cookie';
import './index.css';
import App from './App';

const rootElement = document.getElementById('root');

if (rootElement) {
    const root = ReactDOM.createRoot(rootElement);
    root.render(
        <CookiesProvider>
            <App />
        </CookiesProvider>
    );
}
